export default async (resolve, reject, addLog) => {
    const region = window.JITSIroom.connectionQuality._localStats.serverRegion

    addLog(`Region detected : ${region}`);

    resolve();
};
